import React from "react";

const WorkEntry = ({ index, entry, onDelete, onChange }) => {
  const handleChange = (field, value) => {
    onChange(index, field, value);
  };

  // Define "Type of Work" options
  const typeOfWorkOptions = [
    "Conduiting",
    "CAT 6A UTP Cabling",
    "CAT 6A Patch Panal",
    "Cat 6A, F/UTP Patch Cord (End Point), Blue 3m",
    "Cat 6A, F/UTP Patch Cord (End Point), Blue 5m",
    "Cat 6, F/UTP Patch Cord (End Point), Yellow 5m",
    "Cat 6, F/UTP Patch Cord (In-Rack), Yellow 2m",
    "Cat 6, F/UTP Patch Cord (End Point), Yellow 3m",
    "Simplex Faceplate (White) with Cat 6A",
    "Duplex Faceplate (White) with Cat 6A F/UTP",
    "Cat 6A F/UTP Modular Plug Terminated Link (MPTL)",
    "12 Core Fiber Cabling",
    "Fiber Patch Panal",
    "CAT 5E 25 Pair UTP Cabling",
    "LC Simplex Optical Fiber Pigtail, 1m",
    "LC to LC Duplex Optical Fiber Patch Cord, 3m",
    "6-Port Surface Mount Box (White)",
    "Other",
  ];

  return (
    <div className="work-entry">
      {/* Fields */}
      {[
        { name: "type_of_work", label: "Type of Work", type: "select" },
        { name: "work_description", label: "Work Description", type: "text" },
        { name: "building", label: "Building", type: "text" },
        { name: "level", label: "Level", type: "text" },
        { name: "rack_number", label: "Rack Number", type: "text" },
        { name: "remarks", label: "Remarks", type: "text" },
        { name: "work_order_number", label: "Work Order Number", type: "text" },
        { name: "work_completion_percentage", label: "Work Completion Percentage", type: "number" },
        { name: "qty", label: "Qty", type: "text" },
      ].map((field) => (
        <div key={field.name}>
          <label className="block text-sm font-medium text-gray-700">{field.label}</label>
          {field.type === "select" ? (
            <select
              value={entry[field.name]}
              onChange={(e) => handleChange(field.name, e.target.value)}
              className="block w-full p-2 mt-1 border border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500"
            >
              <option value="">Select</option>
              {typeOfWorkOptions.map((option, idx) => (
                <option key={idx} value={option}>
                  {option}
                </option>
              ))}
            </select>
          ) : (
            <input
              type={field.type}
              value={entry[field.name]}
              onChange={(e) => handleChange(field.name, e.target.value)}
              className="block w-full p-2 mt-1 border border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500"
            />
          )}
        </div>
      ))}

      {/* Delete Button */}
      <button
        type="button"
        onClick={() => onDelete(index)}
        className="w-full px-4 py-2 mt-2 text-white bg-red-500 rounded-md delete-section hover:bg-red-600"
      >
        Delete
      </button>
      <hr className="my-4" />
    </div>
  );
};

export default WorkEntry;
